// extracted by mini-css-extract-plugin
module.exports = {"svg":"Icon_svg__16ORz"};